import { computed } from 'vue';

import { useStore } from '@/composables/useVuexStore';

export const useCurrentUserId = () => {
  const store = useStore();
  return computed<number | undefined>(() => {
    const id: unknown = store.getters.user?.id;
    return typeof id === 'number' ? id : undefined;
  });
};
